import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

import { AuthService } from '../../../services/auth.service';
import { DialogService } from '../../../../shared/dialog/services/dialog.service';
import { DialogDataModel } from '../../../../shared/dialog/models/dialog-data.model';
import { InfoDialogComponent } from '../../../../shared/dialog/components/dialogs/info-dialog/info-dialog.component';

@Component({
  selector: 'lti-login',
  templateUrl: './lti-login.component.html',
})
export class LtiLoginComponent implements OnInit {

  /**
   * Constructor
   *
   * @param {AuthService} authService
   * @param {ActivatedRoute} route
   * @param {Router} router
   * @param {DialogService} dialogService
   */
  public constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
  ) { }

  /**
   * When the component is initialized
   *
   * @return void
   */
  public ngOnInit(): void {
    this.authService.authCode = this.route.snapshot.queryParams['code'];

    this.authService.authProvider = 'lti';

    // cleaning the queryParams: navigate back to itself, without the queryParams
    this.router.navigate([], {
      queryParams: {
        code: null,
      },
      queryParamsHandling: 'merge',
    }).then(() => {
      this.authService.doLtiLogin()
        .pipe(
          finalize(() => {
            this.router.navigate([this.authService.redirectUrl || '/']).then();
          }),
        )
        .subscribe(
          (result) => {
          },
          (error) => {
            const data = new DialogDataModel();

            if (error.title && error.text) {
              data.title = error.title;
              data.text = error.text;
            } else {
              data.title = error.error.message;
            }
            this.authService.clearAccessToken();
            this.dialogService.open(InfoDialogComponent, data);
          },
        );
    });
  }
}
